import { Space, Typography } from "antd";
import { GcloudLinkButton } from "../../o11y/GcloudLinkButton";
import {
  getGcloudProject,
  siteLogsUrl,
  siteTracesUrl,
} from "../../../util/gcloud";

type O11yTabProps = {
  site_id: string;
};

export const O11yTab: React.FC<O11yTabProps> = ({ site_id }) => (
  <div className="w-full">
    <Typography.Paragraph type="secondary" className="mb-4">
      Observability for this site in Google Cloud project{" "}
      <Typography.Text code>{getGcloudProject()}</Typography.Text>. Logs combine
      Cloud Run services (
      <Typography.Text code>jsonPayload.site_id</Typography.Text>) and the
      controller (
      <Typography.Text code>otel.resource.attributes.site_id</Typography.Text>).
    </Typography.Paragraph>

    <Space wrap>
      <GcloudLinkButton href={siteLogsUrl(site_id)} type="primary">
        Open logs
      </GcloudLinkButton>
      <GcloudLinkButton href={siteTracesUrl(site_id)}>
        Open traces
      </GcloudLinkButton>
    </Space>
  </div>
);
